export const iconsConfig = {
  ICONS: {
    store: 'storefront',
    web: 'web',
    app: 'apps',
    tpv: 'contactless',
    social_media: 'group_work',
    phone: 'phone_iphone',
    marketplace: 'ballot',
  },
};

export const getIconName = (str: string) => {
  return iconsConfig.ICONS[str] || '';
};
